import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsers,
  faIdBadge,
  faBook,
  faShieldAlt,
  faCalendarCheck,
  faUmbrellaBeach,
  faMoneyBill,
  faCalendarAlt,
 
  faChartLine,
  faCog,
  faBell,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";

import './Userdashbord.css'


import logo from "../../../assets/images/Picture2.png";
import logo1 from "../../../assets/images/Picture2.png";
import logo2 from "../../../assets/images/Picture2.png";

const Dashboard = () => {
  const navigate = useNavigate();
  
  // Dashboard menu items
  const menuItems = [
    { icon: faUsers, label: "COMPANY", color: "#FF6B35", gradient: "linear-gradient(135deg, #FF6B35, #FF8E53)" },
    { icon: faIdBadge, label: "DIRECTORY", color: "#3498DB", gradient: "linear-gradient(135deg, #3498DB, #5DADE2)" },
    { icon: faBook, label: "PROFILE", color: "#F1C40F", gradient: "linear-gradient(135deg, #F1C40F, #F7DC6F)" },
    { 
      icon: faShieldAlt, 
      label: "INSURANCE", 
      color: "#2E86C1", 
      gradient: "linear-gradient(135deg, #2E86C1, #5DADE2)",
      isNew: true 
    },
    { icon: faCalendarCheck, label: "PROFESSIONAL", color: "#1ABC9C", gradient: "linear-gradient(135deg, #1ABC9C, #48C9B0)" },
    { icon: faUmbrellaBeach, label: "ATTENDANCE", color: "#34495E", gradient: "linear-gradient(135deg, #34495E, #5D6D7E)" },
    { icon: faMoneyBill, label: "PAYROLL", color: "#8E44AD", gradient: "linear-gradient(135deg, #8E44AD, #BB8FCE)" },
    { icon: faCalendarAlt, label: "TICKING", color: "#16A085", gradient: "linear-gradient(135deg, #16A085, #45B39D)" },
  
  ];

  // Navigation handlers
  const handleNavigation = (label) => {
    const routes = {
      "PROFILE": "/userhome",
      "ATTENDANCE": "/attendance",
      "PROFESSIONAL": "/professional",
      "PAYROLL": "/Payroll",
      "TICKTING": "/tickting",
      "COMPANY": "/Usercompany",
      "DIRECTORY": "/Directeory",
    
      "INSURANCE": "/insurance"
    };
    
    if (routes[label]) {
      navigate(routes[label]);
    }
  };

  // Quick stats data
  const [quickStats, setQuickStats] = useState({
    totalEmployees: 142,
    todayAttendance: "92%",
    pendingTasks: 7,
    monthlyRevenue: "$124.8K"
  });

  return (
    <div className="dashboard-container">
      {/* Navbar */}
     
      
      {/* Main Layout */}
      <div className="dashboard-main">
        {/* Sidebar */}
       

        {/* Main Content Area */}
        <div className="dashboard-content">
          {/* Welcome Banner */}
          <div className="welcome-banner">
            <div className="welcome-text">
              <h1>Welcome back, Vikash!</h1>
              <p>Here's what's happening with your company today.</p>
            </div>
            <div className="quick-actions">
              <button className="btn-primary">
                <FontAwesomeIcon icon={faBell} /> Notifications
              </button>
              <button className="btn-secondary">
                <FontAwesomeIcon icon={faSearch} /> Quick Search
              </button>
            </div>
          </div>

          {/* Quick Stats */}
         
          {/* Dashboard Grid */}
          <div className="dashboard-grid">
            {menuItems.map((item, index) => (
              <div 
                key={index} 
                className="dashboard-card"
                onClick={() => handleNavigation(item.label)}
                style={{ background: item.gradient }}
              >
                <div className="card-icon">
                  <FontAwesomeIcon icon={item.icon} />
                  {item.isNew && <span className="new-badge">NEW</span>}
                </div>
                <h3 className="card-title">{item.label}</h3>
                <p className="card-description">Access {item.label.toLowerCase()} features</p>
                <div className="card-hover">
                  <span>Click to open →</span>
                </div>
              </div>
            ))}
          </div>

         
          
        </div>

        {/* Right Sidebar */}
        <div className="dashboard-right-sidebar">
          {/* Advertisement Component */}
          {/* <RightSideAd /> */}
          
          {/* Upcoming Events */}
          <div className="events-card">
            <h3>Upcoming Events</h3>
            <div className="event-item">
              <div className="event-date">
                <span className="event-day">15</span>
                <span className="event-month">MAR</span>
              </div>
              <div className="event-details">
                <h4>Team Meeting</h4>
                <p>10:00 AM • Conference Room A</p>
              </div>
            </div>
            <div className="event-item">
              <div className="event-date">
                <span className="event-day">18</span>
                <span className="event-month">MAR</span>
              </div>
              <div className="event-details">
                <h4>Project Deadline</h4>
                <p>Alpha Release v2.0</p>
              </div>
            </div>
            <button className="btn-view-all">View All Events</button>
          </div>

          {/* Quick Links */}
          <div className="quick-links">
            <h3>Quick Links</h3>
            <a href="#" className="quick-link">HR Policies</a>
            <a href="#" className="quick-link">Leave Calendar</a>
            <a href="#" className="quick-link">Training Materials</a>
            <a href="#" className="quick-link">IT Support</a>
          </div>
        </div>
      </div>

      {/* Chat Support */}
     

      {/* Footer */}
      <footer className="dashboard-footer">
        <div className="footer-content">
          <div className="footer-logo">
            <img src={logo1} alt="Envision" className="footer-logo-img" />
            <span>Envision Integrated Services</span>
          </div>
          <div className="footer-text">
            Empowering Your Future 🚀 • © {new Date().getFullYear()} All Rights Reserved
          </div>
          <div className="footer-links">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms of Service</a>
            <a href="#">Contact Us</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Dashboard;